import React, { useState } from 'react';

import {
    Button,
    Grid,
    makeStyles,
    Paper,
    Snackbar,
    TextField,
    Typography
} from '@material-ui/core';

import MuiAlert from '@material-ui/lab/Alert';

import emailjs from 'emailjs-com';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '1%',
    },
    paper: {
        width: '50vw',
        margin: 'auto',
        padding: '1%',
    },
    submitButton: {
        marginTop: '1%',
        width: '10%',
    },
    emailField: {
        marginTop: '1%',
        // width: '50%',
    },
    textField: {
        marginTop: '1%',
    },
}));

function BugReportForm() {

    const classes = useStyles();

    const [text, setText] = useState('');
    const [email, setEmail] = useState('');
    // const [image, setImage] = useState(null);
    // const [imageName, setImageName] = useState('');

    const [successOpen, setSuccessOpen] = useState(false);
    const [failOpen, setFailOpen] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(true);

    const date = new Date();

    const templateParams = {
        reportDate: date,
        reportEmail: email,
        reportText: text,
        // reportImage: image,
    };

    if (text.length === 0 && submitDisabled === false) {
        setSubmitDisabled(true);
    };
    if (text.length !== 0 && submitDisabled === true) {
        setSubmitDisabled(false);
    };

    const handleTextChange = (event) => {
        setText(event.target.value);
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    // const handleImageChange = (event) => {
    //     setImage(event.target.files[0])
    //     setImageName(event.target.files[0].name)
    // };

    const handleSubmit = () => {
        emailjs.send("service_djkqmvr", "template_kbfj7vb", templateParams, 'tufsIdSTXv-8MRwxd')
            .then((result) => {
                console.log(result.text);
                setText('');
                setEmail('');
                setSuccessOpen(true);
            }, (error) => {
                console.log(error.text);
                setFailOpen(true);
            });
    };

    const handleSnackbarClose = () => {
        setSuccessOpen(false);
        setFailOpen(false);
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Grid container direction='column'>
                    <Typography variant='h6'>
                        Report a Bug
                    </Typography>
                    <TextField
                        className={classes.emailField}
                        variant='filled'
                        label='Response Email (Optional)'
                        onChange={handleEmailChange}
                        value={email}
                    />
                    <TextField
                        className={classes.textField}
                        multiline
                        variant='filled'
                        rows={10}
                        label='Describe the bug in detail, please include your browser and operating system.'
                        onChange={handleTextChange}
                        value={text}
                    />
                    {/* <Grid container direction='row'>
                        <Button component='label'>
                            Upload Image
                            <input type='file' name='image' onChange={handleImageChange} hidden />
                        </Button>
                        <Typography>{imageName}</Typography>
                    </Grid> */}
                    <Grid item>
                        <Button
                            className={classes.submitButton}
                            onClick={handleSubmit}
                            disabled={submitDisabled}
                        >
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
            <Snackbar open={successOpen} autoHideDuration={5000} onClose={handleSnackbarClose}>
                <MuiAlert onClose={handleSnackbarClose} severity='success' variant='filled'>
                    Bug Report Successfully Submitted!
                </MuiAlert>
            </Snackbar>
            <Snackbar open={failOpen} autoHideDuration={5000} onClose={handleSnackbarClose}>
                <MuiAlert onClose={handleSnackbarClose} severity='error' variant='filled'>
                    Bug Report Submission Failed, Please Try Again.
                </MuiAlert>
            </Snackbar>
        </div>
    )
};

export default BugReportForm;
